<template>
  <footer class="app-footer">
    Copyright © 2003–{{ new Date() | moment('YYYY') }}. {{ tenant_full_name }}®. All Rights Reserved
  </footer>
</template>

<script>
  export default {
    name: 'footer',
    data () {
      return {
        tenant: '',
        tenant_full_name: ''
      }
    },
    methods: {
      updateTenant () {
        this.tenant = this.$store.state.tenant
        this.tenant_full_name = this.$store.state.tenant_full_name
      }
    },
    created () {
      this.updateTenant()
    }

  }
</script>

<style>
  .app-footer {
    text-align: center;
    color: #4b585f;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue?5ee5422e